export default __webpack_public_path__ + "static/media/menu.baa3c4bc.svg";